
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.788 20.751H6.212a3.122 3.122 0 0 1-3.118-3.118V9.374a3.122 3.122 0 0 1 3.118-3.118h11.576a3.122 3.122 0 0 1 3.118 3.118v8.26a3.122 3.122 0 0 1-3.118 3.117ZM6.212 8.071c-.718 0-1.303.585-1.303 1.303v8.26c0 .717.585 1.302 1.303 1.302h11.576c.718 0 1.303-.585 1.303-1.303V9.374c0-.718-.585-1.302-1.303-1.302H6.212Z"}}),_c('path',{attrs:{"d":"M19.938 12.79H4.002a.908.908 0 0 1 0-1.817h15.936a.908.908 0 0 1 0 1.816ZM14.41 8.072a.908.908 0 0 1-.907-.908v-2.1h-3.116v2.1a.908.908 0 0 1-1.816 0v-2.11c0-.995.81-1.805 1.806-1.805h3.135c.996 0 1.806.81 1.806 1.806v2.109a.908.908 0 0 1-.907.908Z"}}),_c('path',{attrs:{"d":"M15.56 14.412a.908.908 0 0 1-.907-.908V11.88a.908.908 0 0 1 1.816 0v1.622a.908.908 0 0 1-.908.909ZM8.465 14.412a.908.908 0 0 1-.908-.908V11.88a.908.908 0 0 1 1.816 0v1.622a.908.908 0 0 1-.908.909Z"}})])
          )
        }
      }
    